import { render } from "./ProjectsDropDown.vue?vue&type=template&id=4dadf40b"
import script from "./ProjectsDropDown.vue?vue&type=script&lang=js"
export * from "./ProjectsDropDown.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__